import { List } from 'immutable';
import { xeroCompanyConstants } from '../constants';

export function xero_companies(state = {}, action) {
  switch (action.type) {
    case xeroCompanyConstants.XERO_COMPANY_LIST_LOADING:
      return {
        ...state,
        listLoading: true
      };
    case xeroCompanyConstants.XERO_COMPANY_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case xeroCompanyConstants.XERO_COMPANY_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: [],
        listError: action.error
      };
    case xeroCompanyConstants.XERO_COMPANY_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case xeroCompanyConstants.XERO_COMPANY_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case xeroCompanyConstants.XERO_COMPANY_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case xeroCompanyConstants.XERO_COMPANY_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case xeroCompanyConstants.XERO_COMPANY_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const xeroCompanyIndex = state.items.findIndex(val => val.id == action.response.id);

      if (xeroCompanyIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(xeroCompanyIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case xeroCompanyConstants.XERO_COMPANY_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case xeroCompanyConstants.XERO_COMPANY_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case xeroCompanyConstants.XERO_COMPANY_DELETE_SUCCESS: {
      const { xeroCompanyId } = action;

      if (!state.items) {
        return state;
      }

      const xeroCompanyIndex = state.items.findIndex(val => val.id == xeroCompanyId);

      if (xeroCompanyIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(xeroCompanyIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case xeroCompanyConstants.XERO_COMPANY_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };
    case xeroCompanyConstants.XERO_COMPANY_ERROR_RELOAD:
      return {
        ...state,
        createError: null,
        editError: null
      };

    default:
      return state;
  }
}
